import Stack from '@mui/material/Stack'
import { DoubleProgressBarBlockData } from '../../../../core/types/InsightsInstanceSlotData'

import type { BlockProps } from '../../types'

import ProgressBar from './ProgressBar'

const DoubleProgressBarBlock = ({ payload }: BlockProps<DoubleProgressBarBlockData>) => {
  const { instance_slot_data } = payload
  const { previous, latest } = instance_slot_data.doubleProgressBar
  const percentage = Math.round((previous.value / latest.value) * 100)

  return (
    <Stack sx={{ px: 16, pt: 8, gap: 16 }}>
      <ProgressBar amount={previous.value} label={previous.label} percentage={percentage} />
      <ProgressBar amount={latest.value} isBold={true} label={latest.label} percentage={100} />
    </Stack>
  )
}

export default DoubleProgressBarBlock
